import { faAddressBook, faBuilding, faLifeRing, faLock, faQuestionCircle, faSignOutAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Button, Card, NavDropdown } from "react-bootstrap";
import './mobileNavbar.css'
import { Link, useLocation } from "react-router-dom";
import ModalDomicilios from "Components/ModalDomicilios";
import { Domicilio } from "Interfaces/Domicilio";
import { useApi } from "ApiHooks";
import { useBlockUI } from "Context/BlockUIContext";
import { useErrorModal } from "Context/ErrorModalContext";
import { useIsMobile } from "utils/Utils";
import ModalAyuda from "utils/ModalAyuda";
import { tokenStorage } from "TokenStorage";
import ModalCambiarPassword from "utils/ModalCambiarPassword";

export default function MobileMenu({ usuarioActual, declaranteActual, nombreDeclaranteActual, userInitials, navItems, setShowModalSoporte, setShowModalCambiarPassword,showModalCambiarPassword, cerrarSesion }: any) {

    const api = useApi()
    const { showBlock, hideBlock } = useBlockUI()
    const { showError } = useErrorModal()
    const isMobile = useIsMobile()
    const [isOpen, setIsOpen] = useState(false)
    const [showModalDomicilios, setShowModalDomicilios] = useState(false)
    const [faltaDatoDomicilio, setFaltaDatoDomicilio] = useState(false)
    const [domicilios, setDomicilios] = useState<Domicilio[]>([])
    const [openSection, setOpenSection] = useState<any>(null)
    const [showModalAyuda, setShowModalAyuda] = useState(false)
    const location = useLocation()
    const currentPath = location.pathname
    const handleCloseMobileMenu = () => setIsOpen(false)

    const obtenerDomicilios = async () => {
        setDomicilios([])
        showBlock("Cargando domicilios...")
        try {
            const domicilios = await api.getDomiciliosUsuario()
            setDomicilios(domicilios)

            const domicilio = domicilios?.[0]

            const faltaDato = [
                domicilio?.calle,
                domicilio?.numero,
                domicilio?.codigoPostal,
                domicilio?.telefono,
                domicilio?.provincia,
                domicilio?.localidad
            ].some(v => v == null)

            setFaltaDatoDomicilio(faltaDato)
            if (faltaDato) {
                setShowModalDomicilios(true)
            }
        } catch (error: any) {
            if (!api.isCancel(error)) {
                showError({
                    title: 'Error al cargar datos',
                    message: error?.response?.status === 401 ? 'Se ha vencido el tiempo de la sesión' : error?.response?.data?.message,

                })
            }
        } finally {
            hideBlock()
        }
    }

    useEffect(() => {
        if (isMobile) {
            obtenerDomicilios()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps        
    }, [isMobile])

    return (
        <>
            <Button
                className="d-lg-none mobile-menu-btn p-0 mr-auto"
                onClick={() => setIsOpen(true)}
            >
                ☰
            </Button>

            {isOpen && (
                <div
                    className="mobile-overlay"
                    onClick={() => setIsOpen(false)}
                />
            )}

            <div className={`mobile-drawer ${isOpen ? "open" : ""}`}>
                <div className="mobile-header">
                    <Button
                        variant="link"
                        className="close-btn"
                        onClick={() => setIsOpen(false)}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>

                    <div className="d-flex align-items-center mb-3">
                        <div className="avatar-circle">
                            <div className="user-avatar">{userInitials}</div>

                        </div>
                        <div className="ml-3 text-white">
                            <div style={{ fontSize: 17 }} className="font-weight-bold">Mi Cuenta</div>
                        </div>
                    </div>

                    <Card className="user-info-card">
                        <Card.Body>
                            <small style={{ fontSize: 15 }}>Usuario</small>
                            <div className="font-weight-bold">
                                {usuarioActual}
                            </div>
                            <small style={{ fontSize: 15 }}>Email usuario</small>
                            <div className="font-weight-bold">
                                {tokenStorage?.getEmailUsuario()}
                            </div>
                            <div className="d-flex align-items-start mt-3">
                                <FontAwesomeIcon className="mt-1 mr-1" icon={faBuilding} />

                                <small style={{ fontSize: 13 }}>{declaranteActual}-{nombreDeclaranteActual}</small>
                            </div>
                        </Card.Body>
                    </Card>
                </div>

                <div className="mobile-body">
                    <button
                        className="section-btn"
                        onClick={() =>
                            setOpenSection(openSection === "web" ? null : "web")
                        }
                    >
                        <span style={{ fontFamily: 'Roboto' }}>MENÚ</span>

                    </button>
                    {declaranteActual && (
                        <div className="submenu">

                            {navItems?.map(({ to, label }: any) => (
                                <NavDropdown.Item
                                    key={to}
                                    as={Link}
                                    to={to}
                                    active={currentPath === to}
                                    onClick={handleCloseMobileMenu}
                                >
                                    {label}
                                </NavDropdown.Item>
                            ))}
                        </div>
                    )}
                </div>
                <ModalDomicilios
                    showModalDomicilios={showModalDomicilios}
                    setShowModalDomicilios={setShowModalDomicilios}
                    onClose={() => setShowModalDomicilios(false)}
                    hiddenSelectButton={true}
                    onSelect={(dom) => {
                    }}
                    obtenerDomicilios={obtenerDomicilios}
                    domiciliosData={domicilios}
                    faltaDatoDomicilio={faltaDatoDomicilio}
                />

                <div className="mobile-footer">
                    <Button variant="outline-secondary" as={Link} to="/selectDeclarante" block onClick={() => {
                        handleCloseMobileMenu()
                    }}>
                        <FontAwesomeIcon icon={faBuilding} /> Cambiar Declarante
                    </Button>
                    <Button variant="outline-secondary" block onClick={() => {
                        handleCloseMobileMenu()
                        setShowModalCambiarPassword(true)
                    }}>
                        <FontAwesomeIcon icon={faLock} /> Cambiar Contraseña
                    </Button>

                    <Button variant="outline-secondary" block onClick={() => {
                        handleCloseMobileMenu()
                        setShowModalDomicilios(true)
                    }}>
                        <FontAwesomeIcon icon={faAddressBook} /> Editar Domicilios
                    </Button>
                    <Button variant="info" block onClick={() => {
                        handleCloseMobileMenu()
                        setShowModalSoporte(true)
                    }}>
                        <FontAwesomeIcon icon={faLifeRing} /> Soporte
                    </Button>

                    <Button variant="warning" block onClick={() => {
                        handleCloseMobileMenu()
                        setShowModalAyuda(true)
                    }}>
                        <FontAwesomeIcon icon={faQuestionCircle} /> Ayuda
                    </Button>
                    <Button variant="secondary" block onClick={cerrarSesion}>
                        <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar Sesión
                    </Button>
                </div>
            </div>
            <ModalAyuda showModalAyuda={showModalAyuda} handleCloseModalAyuda={() => setShowModalAyuda(false)} />

            <ModalCambiarPassword setShowModalCambiarPassword={setShowModalCambiarPassword} showModalCambiarPassword={showModalCambiarPassword} />

        </>
    );
}
